<img src="assets/details.svg" class="img-details">
<!--Checking the presence of the events-->
<div *ngIf="event$ | async as event" class="container">
    <div class="row">
        <div class="col-7 d-flex flex-column">
            <div class="row">
                <div class="col-5 d-flex flex-column justify-content-center">
                    <!--Rounded image of an event-->
                    <div class="image event-img" [style.background-image]="'url('+getImage(event.image)+')'"></div>
                    <div *ngIf="theme$ | async as theme" class="theme d-flex justify-content-center my-4 p-3">
                        <div class="image theme-img align-self-center" [style.background-image]="'url('+theme.image+')'"></div>
                        <div class="ml-3 my-auto font-weight-bold">{{theme.name}}</div>
                    </div>
                    <!--Back link-->
                    <a routerLink="/events">
                        <div class="d-flex mt-5">
                            <i class="fas fa-arrow-left mr-3 my-auto"></i>
                            <div class="my-auto">Back</div>
                        </div>
                    </a>
                </div>
                <!--Event details-->
                <div class="col ml-3">
                    <div class="d-flex mb-5">
                        <div class="event-id mr-2">{{event.id.substr(event.id.length - 5)}}</div>
                        <div class="small">hosted by {{event.participants[0].name}}</div>
                    </div>
                    <h6><i class="fas fa-clock"></i>{{event.date | date: 'dd.MM.yyyy'}}, {{event.time}}</h6>
                    <h6><i class="fas fa-home"></i>{{event.place}}</h6>
                    <div class="abstract my-4">
                        <h5>Info</h5>
                        {{event.abstract}}
                    </div>
                </div>
            </div>
        </div>
        <!--List of participants-->
        <div class="col">
            <div class="d-flex position-relative mb-3">
                <img src="assets/team.svg" class="team-img">
                <i class="fas fa-user-friends my-auto"></i><h4 class="m-0">Participants</h4>
            </div>
            <!--Participant details-->
            <participant *ngFor="let participant of event.participants" [participant]="participant" [participantItems]="getParticipantItems(participant.name, event.items)"></participant>
        </div>
    </div>
</div>
